/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, HFlow, Icon, VFlow } from 'bold-ui'
import { formatDate } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

import { ResultadosExamesSolicitadosModel, SolicitacaoExameQueryModel } from '../../model'
import { ResultadoExameComSolicitacaoField } from './ResultadoExameComSolicitacaoField'

interface SolicitacaoExameFieldProps {
  name: MetaPath<ResultadosExamesSolicitadosModel>
  solicitacao: SolicitacaoExameQueryModel
}

export const SolicitacaoExameField = ({ name, solicitacao }: SolicitacaoExameFieldProps) => {
  return (
    <VFlow vSpacing={0.5}>
      <HFlow hSpacing={0.25} alignItems='center'>
        <Icon icon='calendarFilled' fill='primary' size={1} />

        <Heading
          level={5}
          style={css`
            font-weight: normal;
          `}
        >
          <strong>Solicitação de {formatDate(solicitacao.data)}</strong> por{' '}
          {solicitacao.atendimentoProfissional.lotacao.profissional.nome}
          {' | '}
          {solicitacao.atendimentoProfissional.lotacao.cbo.nome}
          {' | '}
          {solicitacao.atendimentoProfissional.lotacao.unidadeSaude.nome}
        </Heading>
      </HFlow>

      <VFlow vSpacing={0.5}>
        {solicitacao.exames.map((exame) => (
          <ResultadoExameComSolicitacaoField key={exame.id} name={name} resultadoExame={exame} />
        ))}
      </VFlow>
    </VFlow>
  )
}
